import React from "react";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";

import AdminCSGORoll from "./admin/AdminCSGORoll";
import AdminRoobet from "./admin/AdminRoobet";
import AdminClash from "./admin/AdminClash";
import AdminCSGORollKazlic from "./admin/AdminCSGORollKazlic";
import AdminHypedropSloth from "./admin/AdminHypedropSloth";
import AdminShuffle from "./admin/AdminShuffle";
import AdminHypedropKazlic from "./admin/AdminHypedropKazlic";
import AdminLuxdrop from "./admin/AdminLuxdrop";
import AdminStake from "./admin/AdminStake";
import AdminCsgobig from "./admin/AdminCsgobig";
import AdminCsbattle from "./admin/AdminCsbattle";
import AdminCsgogem from "./admin/AdminCsgogem";

const AdminIndex = () => {

    const location = useLocation();
    const navigate = useNavigate();

    return (
        <div>
            <div className='container mt-5 mb-5'>

                <div className="row">
                    <div className="col-md-3">
                        <div className="card text-bg-dark">
                            <div className="card-header">Menu</div>
                            <ul className="list-group list-group-flush">
                                <button type="button" onClick={()=>navigate('/admin/csgo-roll')} className="list-group-item list-group-item-action text-start" aria-current="true">
                                    CSGO Roll (SLOTH)
                                </button>
                                <button type="button" onClick={()=>navigate('/admin/hypedrop-sloth')} className="list-group-item list-group-item-action text-start" aria-current="true">
                                    Hypedrop (SLOTH)
                                </button>
                                <button type="button" onClick={()=>navigate('/admin/hypedrop-kazlic')} className="list-group-item list-group-item-action text-start" aria-current="true">
                                    Hypedrop (Kazlic)
                                </button>
                                <button type="button" onClick={()=>navigate('/admin/csgo-roll-kazlic')} className="list-group-item list-group-item-action text-start" aria-current="true">
                                    CSGO Roll (Kazlic)
                                </button>
                                {/*<button type="button" onClick={()=>navigate('/admin/roobet')} className="list-group-item list-group-item-action text-start" aria-current="true">*/}
                                {/*    Roobet*/}
                                {/*</button>*/}
                                {/*<button type="button" onClick={()=>navigate('/admin/clashgg')} className="list-group-item list-group-item-action text-start" aria-current="true">*/}
                                {/*    ClashGG*/}
                                {/*</button>*/}
                                <button type="button" onClick={()=>navigate('/admin/shuffle')} className="list-group-item list-group-item-action text-start" aria-current="true">
                                    Shuffle
                                </button>
                                <button type="button" onClick={()=>navigate('/admin/luxdrop')} className="list-group-item list-group-item-action text-start" aria-current="true">
                                    Luxdrop
                                </button>
                                <button type="button" onClick={()=>navigate('/admin/stake')} className="list-group-item list-group-item-action text-start" aria-current="true">
                                    Stake
                                </button>
                                <button type="button" onClick={()=>navigate('/admin/csgobig')} className="list-group-item list-group-item-action text-start" aria-current="true">
                                    CSGO:BIG
                                </button>
                                <button type="button" onClick={()=>navigate('/admin/csbattle')} className="list-group-item list-group-item-action text-start" aria-current="true">
                                    CSBattle
                                </button>
                                <button type="button" onClick={()=>navigate('/admin/csgogem')} className="list-group-item list-group-item-action text-start" aria-current="true">
                                    CSGOGem
                                </button>
                            </ul>
                        </div>

                    </div>
                    <div className="col-md-9">
                        <Routes location={location}>
                            <Route path="csgo-roll" element={<AdminCSGORoll />} />
                            <Route path="hypedrop-sloth" element={<AdminHypedropSloth />} />
                            <Route path="hypedrop-kazlic" element={<AdminHypedropKazlic />} />
                            <Route path="csgo-roll-kazlic" element={<AdminCSGORollKazlic />} />
                            <Route path="roobet" element={<AdminRoobet />} />
                            <Route path="clashgg" element={<AdminClash />} />
                            <Route path="shuffle" element={<AdminShuffle />} />
                            <Route path="luxdrop" element={<AdminLuxdrop />} />
                            <Route path="stake" element={<AdminStake />} />
                            <Route path="csgobig" element={<AdminCsgobig />} />
                            <Route path="csbattle" element={<AdminCsbattle />} />
                            <Route path="csgogem" element={<AdminCsgogem />} />
                        </Routes>
                    </div>
                </div>


            </div>

        </div>
    );
}

export default AdminIndex;
